import find from 'lodash.find';
import assign from 'lodash.assign';
import groupBy from 'lodash.groupby';
import uniqBy from 'lodash.uniqby';
import flatMapDeep from 'lodash.flatmapdeep';
import map from 'lodash.map';
import orderBy from 'lodash.orderby';
import includes from 'lodash.includes';
import filter from 'lodash.filter';
import some from 'lodash.some';
// import take from 'lodash.take';
import size from 'lodash.size';
import { lSportsConfig } from '../../config/lsports.config';

export const assignLocationSort = function (locationObject, sportId) {
    let sport = find(lSportsConfig.sort.location, (i) => {
        return i.SportId === sportId;
    });

    let location = null;

    if (sport) {
        location = find(sport.Locations, (i) => {
            return i.Id === locationObject.Id;
        });
    }

    return location
        ? assign(locationObject, location)
        : assign(locationObject, {
              Id: locationObject.Id,
              Sort: locationObject.Id,
          });
};

export const assignSportSort = function (sportObject) {
    let sport = find(lSportsConfig.sort.sport, (i) => {
        return i.Id === sportObject.Id;
    });

    return sport ? assign(sportObject, sport) : assign(sportObject, { Id: sportObject.Id, Sort: sportObject.Id });
};

export const groupByMulti = function (obj, values, keys, context) {
    if (!values.length) return obj;
    var byFirst = groupBy(obj, values[0], context),
        rest = values.slice(1);
    var keyRest = keys.slice(1);
    for (var prop in byFirst) {
        let obj = {
            Id: parseInt(prop),
        };
        obj[keyRest[0]] = groupByMulti(byFirst[prop], rest, keyRest, context);

        byFirst[prop] = obj;
    }
    return byFirst;
};

export const ungroupEvents = function (group) {
    let events = uniqBy(flatMapDeep(group, 'Locations'), 'Id');
    events = uniqBy(flatMapDeep(events, 'Leagues'), 'Id');
    return uniqBy(flatMapDeep(events, 'Events'), 'FixtureId');
};

export const groupEvents = function (events) {
    events = groupByMulti(events, ['Fixture.Sport.Id', 'Fixture.Location.Id', 'Fixture.League.Id'], ['Sport', 'Locations', 'Leagues', 'Events']);

    events = map(events, (e) => {
        e.Locations = map(e.Locations, (l) => {
            return assignLocationSort(l, e.Id);
        });

        e.Locations = orderBy(e.Locations, ['Sort'], 'dec');
        return assignSportSort(e);
    });

    return events;
};

export const searchEvents = function (filteredEvents, value, returnAllIfEmpty = true) {
    let events = returnAllIfEmpty ? filteredEvents : [];

    if (value !== null && value !== '') {
        events = filter(filteredEvents, function (item) {
            return some(item.Fixture.Participants, function (tag) {
                return includes(tag.Name.toLowerCase(), value.toLowerCase()); //startsWith
            });
        });

        // if (events.length === 0) {
        //   return null;
        // } else {
        //   events = take(events, 50);
        // }
    }
    return events;
};

export const filterEvents = function (selectedSports, selectedLocations, filteredEvents) {
    let isSelectedLocationsEmpty = size(selectedLocations) === 0;

    let isSelectedSportsEmpty = size(selectedSports) === 0;

    return filter(filteredEvents, function (item) {
        return some(item.Fixture, function (tag) {
            return (
                (isSelectedSportsEmpty || includes(selectedSports, item.Fixture.Sport.Id)) &&
                (isSelectedLocationsEmpty || includes(selectedLocations, item.Fixture.Location.Id.toString()))
            );
        });
    });
};

export const filterEventsByLeague = function (selectedSport, selectedLocation, selectedLeague, mainEvents) {
    let events = [];

    let sport = find(mainEvents, { Id: selectedSport });
    if (sport === undefined) return events;
    let location = find(sport.Locations, { Id: selectedLocation });
    if (location === undefined) return events;
    let league = find(location.Leagues, { Id: selectedLeague });

    events = [
        {
            Id: sport.Id,
            Name: sport.Name,
            Count: sport.Count,
            EventCount: sport.EventCount,
            Locations: [
                {
                    Id: location.Id,
                    Name: location.Name,
                    Count: location.Count,
                    Leagues: [
                        {
                            Id: league.Id,
                            Name: league.Name,
                            Count: league.Count,
                            Events: league.Events,
                        },
                    ],
                    Description: location.Description,
                    Sort: location.Sort,
                },
            ],
            Description: sport.Description,
            Sort: sport.Sort,
            Icon: sport.Icon,
        },
    ];

    return events;
};

export const filterLocations = function (filteredEvents) {
    let locations = map(filteredEvents, 'Fixture.Location');
    locations = uniqBy(locations, 'Id');

    return locations;
};
